import { IconDefinition, faChevronRight } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { useNavigate } from "react-router-dom";

type DashboardCardButton = {
  link: string;
  text: string;
};

type DashboardCardProps = {
  icon: IconDefinition;
  title: string;
  bodyContent: JSX.Element;
  button?: DashboardCardButton;
  isBusy: boolean;
  "data-test-id"?: string;
};

const DashboardCard = (props: DashboardCardProps) => {
  const navigate = useNavigate();
  return (
    <div className="card dashboard-card">
      <ActivityIndicator isBusy={props.isBusy}>
        <div className="card-body">
          <div className="d-flex justify-content-center align-items mb-2 heading-text">
            <FontAwesomeIcon icon={props.icon} className="me-3 cpl-brand-primary" size="2x" />
            <span className="d-inline-flex align-items-center fs-5">{props.title}</span>
          </div>
          <div className="mx-20 mb-2" style={{ borderWidth: 2, borderBottomStyle: "dotted" }}></div>
          <div className="d-flex justify-content-center align-items fs-5">{props.bodyContent}</div>
          {props.button && (
            <div className="d-flex justify-content-center mt-auto">
              <div
                className="cpl-btn cpl-btn-primary rounded d-flex justify-content-center align-items-center"
                style={{ width: "200px" }}
                onClick={() => navigate(props.button!.link)}
                data-test-id={props["data-test-id"]}
              >
                <span className="me-2">{props.button.text}</span>
                <FontAwesomeIcon icon={faChevronRight} />
              </div>
            </div>
          )}
        </div>
      </ActivityIndicator>
    </div>
  );
};

type ValueContentProps = {
  value: number;
  text: string;
};

export const DashboardCardValueContent = (props: ValueContentProps) => {
  return (
    <div>
      <span className="cpl-text-primary me-2">{props.value}</span> <span className="cpl-text-body">{props.text}</span>
    </div>
  );
};

type TextContentProps = {
  text: string;
};

export const DashboardCardTextContent = (props: TextContentProps) => {
  return <div>{props.text}</div>;
};

export default DashboardCard;
